export default __webpack_public_path__ + "static/media/pl_nurse4.958a2802.png";